export const LOAD_PRACTICE_EXAM_INFORMATION =
  'practice_exams/LOAD_PRACTICE_EXAM_INFORMATION';
export const BUILD_PRACTICE_EXAM = 'practice_exams/BUILD_PRACTICE_EXAM';
export const REMOVE_QUESTION = 'practice_exams/REMOVE_QUESTION';
export const ACTIVATE_EXAM = 'practice_exams/ACTIVATE_EXAM';
export const BUILD_ALL_EXAMS = 'practice_exams/BUILD_ALL_EXAMS';
export const CHECK_BUILD_PE_PROGRESS = 'practice_exams/CHECK_BUILD_PE_PROGRESS';
export const CREATE_PRACTICE_EXAM = 'practice_exams/CREATE_PRACTICE_EXAM';
